import { useState, useEffect } from "react";
import { api } from "@/lib/api";
import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import ServicesSection from "@/components/ServicesSection";
import HowItWorks from "@/components/HowItWorks";
import PaymentSection from "@/components/PaymentSection";
import Testimonials from "@/components/Testimonials";
import TrustSection from "@/components/TrustSection";
import FAQ from "@/components/FAQ";
import Footer from "@/components/Footer";
import FloatingWhatsApp from "@/components/FloatingWhatsApp";
import RequestWizard from "@/components/RequestWizard";

export default function LandingPage() {
  const [wizardOpen, setWizardOpen] = useState(false);
  const [selected, setSelected] = useState(null);
  const [services, setServices] = useState([]);
  const [pixDiscount, setPixDiscount] = useState(10);

  useEffect(() => {
    api.get("/services").then(({ data }) => setServices(data)).catch(() => {});
    api.get("/settings").then(({ data }) => setPixDiscount(data.pix_discount_percent)).catch(() => {});
  }, []);

  const openWizard = (service = null) => {
    setSelected(service);
    setWizardOpen(true);
  };

  return (
    <div className="bg-slate-50">
      <Navbar onStart={() => openWizard()} />
      <main>
        <Hero onStart={() => openWizard()} />
        <ServicesSection services={services} onSelect={(s) => openWizard(s)} />
        <HowItWorks />
        <PaymentSection />
        <Testimonials />
        <TrustSection />
        <FAQ />
      </main>
      <Footer />
      <FloatingWhatsApp />
      <RequestWizard open={wizardOpen} onClose={() => setWizardOpen(false)} initialService={selected} services={services} pixDiscount={pixDiscount} />
    </div>
  );
}
